<template>
	<div id="onboardingOptions" class="container-fluid mt-2">
		<Breadcrumb :back="'/kpi'" />
		<div class="row">
			<div class="col-md-12">
				<div class="col-md-12 d-flex justify-content-end align-items-center">
					<input class="form-control mx-2" style="width:150px" type="date" v-model="from" name="from" />
					<input class="form-control me-2" style="width:150px" type="date" v-model="to" name="to" />
					<button class="btn btn-primary" @click="applyFilters()">Apply</button>
				</div>
			</div>
		</div>
		<div class="row my-5">
			<div v-if="!loading" class="col-md-3">
				<div class="text-center">
					<span class="mx-1"
						>Great <b>{{ this.customerRatings.datasets[0].data[2] }}</b>
					</span>
					<span class="mx-1"
						>Good <b>{{ this.customerRatings.datasets[0].data[1] }}</b></span
					>
					<span class="mx-1"
						>Bad <b>{{ this.customerRatings.datasets[0].data[0] }}</b></span
					>
				</div>
				<StatsPieChart v-if="!loading" :data="customerRatings" :height="200" class="mb-4" />
				<div class="text-center">
					<h3 class="text-success">Happines score is {{ happinesScore }}%</h3>
				</div>
			</div>
			<div v-else class="col-md-3">
				<div class="d-flex justify-content-center">
					<div class="spinner-border" role="status">
						<span class="sr-only">Loading...</span>
					</div>
				</div>
			</div>
			<div class="col-md-9">
				<div class="row p-5">
					<div class="col-md-3  text-light p-3">
						<div class="stat rounded bg-secondary p-3 text-center">
							<h4>Customers Helped</h4>
							<h2 v-if="!loading">{{ customersHelped }}</h2>
							<div v-else class="spinner-border" role="status">
								<span class="sr-only">Loading...</span>
							</div>
						</div>
					</div>
					<div class="col-md-3  text-light p-3">
						<div class="stat rounded bg-secondary p-3 text-center">
							<h4>Replies sent</h4>
							<h2 v-if="!loading">{{ repliesSent }}</h2>
							<div v-else class="spinner-border" role="status">
								<span class="sr-only">Loading...</span>
							</div>
						</div>
					</div>
					<div class="col-md-3  text-light p-3">
						<div class="stat rounded bg-secondary p-3 text-center">
							<h4>Replies Per Day</h4>
							<h2 v-if="!loading">{{ repliesPerDay }}</h2>
							<div v-else class="spinner-border" role="status">
								<span class="sr-only">Loading...</span>
							</div>
						</div>
					</div>
					<div class="col-md-3  text-light p-3">
						<div class="stat rounded bg-secondary p-3 text-center">
							<h4>Closed</h4>
							<h2 v-if="!loading">{{ closed }}</h2>
							<div v-else class="spinner-border" role="status">
								<span class="sr-only">Loading...</span>
							</div>
						</div>
					</div>
				</div>
				<div class="p-5">
					<table class="table table-hover">
						<thead>
							<tr>
								<td>Name</td>
								<td>CSAT</td>
								<td>Replies Sent</td>
								<td>Closed</td>
								<td>Customers Helped</td>
							</tr>
						</thead>
						<tbody>
							<template v-if="personal && !loadingPersonal">
								<tr v-for="support in personal" :key="support.id">
									<td>{{ support.name }}</td>
									<td>{{ support.total }}</td>
									<td>{{ support.replies }}</td>
									<td>{{ support.closed }}</td>
									<td>{{ support.helped }}</td>
								</tr>
							</template>
							<template v-else>
								<tr>
									<div class="spinner-border" role="status">
										<span class="sr-only">Loading...</span>
									</div>
								</tr>
							</template>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import restApi from '../../api/index'
import Breadcrumb from '../../components/onboarding/breadcrumb/Breadcrumb.vue'
import StatsPieChart from '@/components/charts/StatsPieChart'

export default {
	name: 'KpiSupport',
	data() {
		return {
			loading: false,
			loadingPersonal: true,
			customerRatings: {
				labels: ['Bad', 'Good', 'Great'],
				datasets: [
					{
						barThickness: 30,
						label: 'Happines',
						backgroundColor: ['#ff6384', '#CCC', '#28c76f'],
						data: [],
					},
				],
			},
			happinesScore: '98.12',
			customersHelped: 123,
			repliesSent: 234,
			repliesPerDay: 85,
			closed: 266,
			data: [],
			personal: null,
			from: null,
			to: null,
		}
	},
	components: { Breadcrumb, StatsPieChart },
	computed: {
		...mapState(['authUser']),
		...mapGetters(['isAuth']),
	},
	mounted() {},
	created() {
		let today = new Date()
		this.from = this.formatDate(new Date(today.getFullYear(), today.getMonth(), 1))
		this.to = this.formatDate(new Date())
		this.getSupportData()
		this.getPersonalData()
	},
	methods: {
		// Get support data
		getSupportData() {
			this.loading = true
			restApi
				.get('/kpi/support', { params: { from: this.from, to: this.to } })
				.then(({ data }) => {
					this.data = data
					this.loading = false
					this.happinesScore = data.ratings.happines
					this.customerRatings.datasets[0].data = []
					this.customerRatings.datasets[0].data.push(data.ratings.bad)
					this.customerRatings.datasets[0].data.push(data.ratings.good)
					this.customerRatings.datasets[0].data.push(data.ratings.great)
					this.customersHelped = data.ratings.helped
					this.repliesSent = data.ratings.replies_sent
					this.closed = data.ratings.closed_conversations
					this.repliesPerDay = data.ratings.replies_per_day
				})
				.catch(error => {
					this.loading = false
					console.log(error)
				})
		},

		// Get support data
		getPersonalData() {
			this.loadingPersonal = true
			restApi
				.get('/kpi/support-personal', { params: { from: this.from, to: this.to } })
				.then(({ data }) => {
					this.personal = data
					this.loadingPersonal = false
				})
				.catch(error => {
					this.loadingPersonal = false
					console.log(error)
				})
		},

		formatDate(date) {
			const year = date.toLocaleString('default', { year: 'numeric' })
			const month = date.toLocaleString('default', {
				month: '2-digit',
			})
			const day = date.toLocaleString('default', { day: '2-digit' })
			return [year, month, day].join('-')
		},

		applyFilters() {
			this.getPersonalData()
			this.getSupportData()
		},
	},
	watch: {},
}
</script>
